// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__27nFP","content":"LayoutSettings_content__3inm0"};